module.exports = __webpack_public_path__ + "static/media/GH.364d023b.svg";